import { EventBus } from '@/event-bus';
import { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import { HTTP } from './http.api';

export abstract class BaseService {
  protected readonly baseUrl: string =
    process.env.NODE_ENV === 'production' ? 'https://simplrbooks.com' : 'http://localhost:3000';

  protected readonly API: AxiosInstance;

  constructor() {
    this.API = HTTP;
    this.API.defaults.baseURL = this.baseUrl;
  }

  protected handleError(error: AxiosError): void {
    // Error
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
      EventBus.$emit('api-error', error.response.data.error);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      EventBus.$emit('request-error', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      EventBus.$emit('internal-error', error.message);
    }
    console.log(error.config);
  }

  protected get<T>(url: string): Promise<IApi<T>> {
    return new Promise((resolve, reject) => {
      this.API.get<IApi<T>>(url)
        .then((response: AxiosResponse<IApi<T>>) => {
          resolve(response.data);
        })
        .catch((error: AxiosError) => {
          this.handleError(error);
          reject(error);
        });
    });
  }

  protected downloadItem(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.API.get(url)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          this.handleError(error);
          reject(error);
        });
    });
  }

  protected postItem<T>(url: string, item: any): Promise<IApi<T>> {
    return new Promise((resolve, reject) => {
      this.API.post<IApi<T>>(url, item)
        .then((response: AxiosResponse<IApi<T>>) => {
          resolve(response.data);
        })
        .catch((error: AxiosError) => {
          this.handleError(error);
          reject(error);
        });
    });
  }

  protected putItem<T>(url: string, item: any): Promise<IApi<T>> {
    return new Promise((resolve, reject) => {
      this.API.put<IApi<T>>(url, item)
        .then((response: AxiosResponse<IApi<T>>) => {
          resolve(response.data);
        })
        .catch((error: AxiosError) => {
          this.handleError(error);
          reject(error);
        });
    });
  }

  protected deleteItem<T>(url: string): Promise<IApi<T>> {
    return new Promise((resolve, reject) => {
      this.API.delete(url)
        .then((response: AxiosResponse<IApi<T>>) => {
          resolve(response.data);
        })
        .catch((error: AxiosError) => {
          this.handleError(error);
          reject(error);
        });
    });
  }
}
